<template>
  <TabMenu :model="navItems" />
</template>
<script>
import TabMenu from 'primevue/tabmenu';
import { RouteNames } from '@/data/routes';

export default {
  components: {
    TabMenu,
  },
  props: {
    showVendorTab: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isRouteActive(route) {
      return this.$route.name === route;
    },
  },
  computed: {
    navItems() {
      const navArray = [
        {
          label: this.$t('components.paymentsNav.paymentsTab'),
          to: { name: RouteNames.HOME.INITIAL },
          disabled: this.isRouteActive(RouteNames.HOME.INITIAL),
        },
        {
          label: this.$t('components.paymentsNav.vendorsTab'),
          to: { name: RouteNames.MCA.VENDOR_LIST },
          disabled: this.isRouteActive(RouteNames.MCA.VENDOR_LIST),
        },
      ];
      if (!this.showVendorTab) {
        navArray.splice(1, 1);
      }
      return navArray;
    },
  },
};
</script>
<style lang="less" scoped>
:deep(.p-tabmenuitem.p-highlight.p-disabled) {
  opacity: 1;
}
</style>
